import styled from 'styled-components';
import { CARD_PADDING_MOBILE_PX, CARD_PADDING_PX } from '../constants';
import { cardMobile } from '../utils';

export const Root = styled.div`
  padding: 30px ${CARD_PADDING_PX}px 0px;

  ${cardMobile`
    padding-left: ${CARD_PADDING_MOBILE_PX}px;
    padding-right: ${CARD_PADDING_MOBILE_PX}px;
  `}
`;
